import React, {useRef, useState} from "react";
import {Box, Form, Text} from "grommet";
import OAuthManager from "./OAuthManager";
import {handleErrors} from "../utils/errors";
import StatusMessage from "./StatusMessage";
import {
    IconPlus
} from '@tabler/icons-react';
import FontAwesomeIcon from "./FontAwesomeIcon";
import Button from "./Button";

const LinkQuickbooks = ({
    userId,
    onLinked,
    ctaColor,
    cta,
    buttonWrapperProps,
    importCustomers = false // by default do not import customers when linking QB
}) => {

    const [isOauthWindowOpen, setIsOauthWindowOpen] = useState(false);
    const [oauthError, setOauthError] = useState();
    const oAuthManagerRef = useRef();

    const onSubmit = ({ value }) => {
        fetch('/api/settings/quickbooks', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...value, ...{ user_id: userId } }),
        })
            .then(handleErrors)
            .catch(setOauthError)
            .then((data) => {
                if (data.hasOwnProperty('auth_url')) {
                    oAuthManagerRef.current.showAuthDialog(data.auth_url);
                }
            });
    };
    const onComplete = () => {
        setIsOauthWindowOpen(false);
        if (importCustomers) {
            fetch("/api/settings/quickbooks/import-quickbooks-customers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({}),
            })
                .then(handleErrors)
                .then(() => {
                    onLinked && onLinked();
                });
        } else {
            onLinked && onLinked();
        }
    };

    const onError = (err) => {
        setIsOauthWindowOpen(false);
        setOauthError(err);
    }

    const onDismiss = () => {
        setIsOauthWindowOpen(false);
        setOauthError(undefined);
    }

    const onOpen = () => {
        setOauthError(undefined);
        setIsOauthWindowOpen(true);
    }

    return (
        <Box>
            <OAuthManager
                ref={oAuthManagerRef}
                onComplete={onComplete}
                onError={onError}
                onDismiss={onDismiss}
                onOpen={onOpen}/>
            {oauthError && (<StatusMessage apiError={oauthError} />)}
            <Form
                onSubmit={onSubmit}
                messages={{
                    required: 'This field is required',
                }}
            >
                <Box pad={{ horizontal: 'none' }} {...buttonWrapperProps}>
                    {cta || (<Button
                        event={{section: 'link_quickbooks_oauth', element: 'connect'}}
                        type="submit"
                        primary
                        icon={
                            <Box>
                                <FontAwesomeIcon SelectedIcon={IconPlus} color="text" size="xsmall"/>
                            </Box>
                        }
                        label={<Text color="text">Connect account</Text>}
                        disabled={isOauthWindowOpen}
                        data-testid="quickbooks-form-submit"
                        {...(ctaColor? {color: ctaColor, ctaColor} : {})}
                    />)}
                </Box>
            </Form>
        </Box>
    );
};

export default LinkQuickbooks;
